export function dataInRequest(params = {}) {
  return {
    type: '@raizenerrologintegracaomovimentacaoposto/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@raizenerrologintegracaomovimentacaoposto/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@raizenerrologintegracaomovimentacaoposto/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@raizenerrologintegracaomovimentacaoposto/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@raizenerrologintegracaomovimentacaoposto/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@raizenerrologintegracaomovimentacaoposto/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@raizenerrologintegracaomovimentacaoposto/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@raizenerrologintegracaomovimentacaoposto/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@raizenerrologintegracaomovimentacaoposto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@raizenerrologintegracaomovimentacaoposto/RECORD_FILTERING',
    payload: { params },
  };
}
